export default {
  // API_ENDPOINT: 'http://localhost:8000/api'
  API_ENDPOINT: 'https://warm-river-99681.herokuapp.com/api'
}
